import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../middleware/ThemeContext';

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

`;

const ModalContent = styled.div(({ theme }) => ({
  background: theme?.colors?.contentBackground,
  borderRadius: '10px',
  padding: '1rem',
  width: '50vw',
  overflowY: 'auto',
}));

interface ModalWrapperProps {
  children: React.ReactNode;
  onClose: () => void;
}

const ModalWrapper: React.FC<ModalWrapperProps> = ({ children, onClose }) => {
  const { theme } = useTheme();
  return (
    <Backdrop onClick={onClose}>
      <ModalContent theme={theme} onClick={e => e.stopPropagation()}>
        {children}
      </ModalContent>
    </Backdrop>
  );
};

export default ModalWrapper;
